import React from 'react';

export const Unfold = ({
  className,
  color,
  height,
  width,
}: {
  className?: string;
  color?: string;
  height?: string;
  width?: string;
}) => (
  <svg
    height={height ?? '19px'}
    width={width ?? '19px'}
    viewBox="0 0 19 19"
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_181_51911"
      className="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      height={height ?? '19px'}
      width={width ?? '19px'}
    >
      <rect x="0.852051" y="0.849487" width="18" height="18" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_181_51911)">
      <path
        d="M7.52705 11.4243L6.47705 12.4743L9.85205 15.8493L13.2271 12.4743L12.1771 11.4243L9.85205 13.7493L7.52705 11.4243ZM9.85205 3.84933L6.47705 7.22433L7.52705 8.27433L9.85205 5.94933L12.1771 8.27433L13.2271 7.22433L9.85205 3.84933Z"
        fill={color || '#383463'}
      />
    </g>
  </svg>
);
